import { useState } from "react";

const useHome = () => {
  const [page, setPage] = useState<number>(1);

  return {
    page,
    setPage,
  };
};

export default useHome;
